"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var immutable_1 = require("immutable");
var Agents = require("@findify/agent");
var analytics_1 = require("@findify/analytics");
exports.Context = react_1.createContext({});
exports.createProvider = function (type, onCreate) { return function (_a) {
    var apiKey = _a.apiKey, agent = _a.agent, options = _a.options, defaults = _a.defaults, config = _a.config, _b = _a.storeKey, storeKey = _b === void 0 ? 'default' : _b, query = _a.query, children = _a.children;
    var _c = react_1.useMemo(function () {
        if (agent && !agent.config.immutable) {
            throw new Error("\n        Agent should be in \"immutable\" mode, to work with connectors.\n        Add \"immutable: true\" to your Agent initializer\n      ");
        }
        return [
            agent && agent.config.key || apiKey,
            config || immutable_1.Map()
        ];
    }, []), _key = _c[0], _config = _c[1];
    var _d = react_1.useMemo(function () {
        var _analytics = analytics_1.default(__assign({ key: _key, events: _config.get('analytics', immutable_1.Map()).toJS() }, _config.get('platform', immutable_1.Map()).toJS()));
        var _agent = agent || new Agents[type](__assign({ key: _key, user: _analytics.user, immutable: true, retryCount: type === 'Autocomplete' ? 0 : void 0 }, options));
        return [_analytics, _agent];
    }, [storeKey]), _analytics = _d[0], _agent = _d[1];
    react_1.useEffect(function () {
        for (var key in query)
            _agent.set(key, query[key]);
    }, [query]);
    react_1.useEffect(function () {
        if (defaults)
            _agent.defaults(defaults);
    }, [defaults]);
    react_1.useEffect(function () {
        if (onCreate)
            onCreate(_agent);
    }, [_agent]);
    var context = react_1.useContext(exports.Context);
    var value = react_1.useMemo(function () {
        var _a;
        return (__assign({}, context, (_a = {}, _a[storeKey] = {
            analytics: _analytics,
            agent: _agent,
            config: _config,
        }, _a)));
    }, [context]);
    return react_1.createElement(exports.Context.Provider, { value: value }, children);
}; };
//# sourceMappingURL=createProvider.js.map